import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, effect } from '@angular/core';
import { UserService } from './user-service';

@Directive({ selector: '[role]', standalone: false })
export class RoleDirective {
    @Input('role') requiredRole: string;

    hasAccess = false;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private userService: UserService
    ) {
        effect(() => {
            const user = this.userService.user();
            console.log('role', this.requiredRole, user);
            if (user && user.roles && user.roles.includes(this.requiredRole)) {
                if (this.hasAccess) {
                    return;
                }
                this.viewContainer.createEmbeddedView(this.templateRef);
                this.hasAccess = true;
            } else {
                this.viewContainer.clear();
                this.hasAccess = false;
            }
        });
    }
}
